import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, Inject, OnDestroy, OnInit, Renderer2, TemplateRef, ViewChild, ViewContainerRef, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Observable, Subject } from 'rxjs';
import { debounceTime, map, startWith, takeUntil, tap } from 'rxjs/operators';
import { FuseConfirmationService } from '@fuse/services/confirmation';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { assign } from 'lodash';
import { AlertMessageService } from 'app/core/common/alert.message.service';
import { ReportsService } from 'app/modules/admin/transactions/inwards/reports.service';
import { ReplacementCostLandService } from '../replacement-cost-land.service';
import { CommonDropDown, SingleCommonDropDown } from 'app/core/common/types/dropdown.types';
import { LookupService } from 'app/core/common/services/lookup.service';
import { ReplacementCostLand } from '../replacement-cost-land.types';

@Component({
    selector: 'replacement-cost-land-details',
    templateUrl: './replacement-cost-land-details.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReplacementCostLandDetailsComponent implements OnInit, OnDestroy {

    replacementCostLand: ReplacementCostLand;
    replacementCostLandForm: FormGroup;
    dialogTitle = `New ReplacementCost Land`
    alert: any;
    reportType: string;
    cost: number;
    private _unsubscribeAll: Subject<any> = new Subject<any>();
    options: CommonDropDown[];
    filteredOptions: Observable<CommonDropDown[]>;


    replacementCostLandFilterForm: FormGroup;
    /**
     * Constructor
     */
    constructor(
        private _changeDetectorRef: ChangeDetectorRef,
        @Inject(MAT_DIALOG_DATA) private _data: {
            replacementCostLand: ReplacementCostLand,
            reportType: string
        },
        private replacementCostLandService: ReplacementCostLandService,
        private _matDialogRef: MatDialogRef<ReplacementCostLandDetailsComponent>,
        private _formBuilder: FormBuilder,
        private _fuseConfirmationService: FuseConfirmationService,
        private _alertMessage: AlertMessageService,
        private _lookupService: LookupService
    ) {
        this.reportType = this._data.reportType;
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
        // Open the drawer
        this.replacementCostLandForm = this._formBuilder.group({
            id: [''],
            reportId: [this._data.replacementCostLand.reportId],
            type: [this._data.replacementCostLand.type, [Validators.required]],
            // type: ['', [Validators.required]],
            area: [this._data.replacementCostLand.area],
            rate: [this._data.replacementCostLand.rate],
            cost: [this._data.replacementCostLand.cost],
            orderIndex: [this._data.replacementCostLand.orderIndex],
        });

        if (this._data.replacementCostLand.id) {
            // Request the data from the server
            this.replacementCostLandService.getReplacementCostLand(this._data.replacementCostLand.id)
                .subscribe((res) => {
                    if (res.isSuccess) {
                        this.replacementCostLand = res.result;
                        this.dialogTitle = `Edit ReplacementCostLand`;
                        this.replacementCostLandForm.patchValue(this.replacementCostLand);
                    }
                    else {
                        this._alertMessage.error(res.errors.join('\n'));
                        this.onClose();
                    }
                });
        }
        this.replacementCostLandForm.valueChanges
            .pipe(
                debounceTime(500),
                takeUntil(this._unsubscribeAll)
            )
            .subscribe((value) => {
                if (value.area && value.rate)
                    this.replacementCostLandForm.get('cost').patchValue(value.area * value.rate);
            });
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Close the drawer
     */
    // closeDrawer(): Promise<MatDrawerToggleResult> {
    //     return this._optionTypesListComponent.matDrawer.close();
    // }

    /**
     * Track by function for ngFor loops
     *
     * @param index
     * @param item
     */
    trackByFn(index: number, item: any): any {
        return item.id || index;
    }

    setResetForm(oldData: ReplacementCostLand) {
        this._data.replacementCostLand as ReplacementCostLand;
        this._data.replacementCostLand.reportId = oldData.reportId;
        this._data.replacementCostLand.orderIndex = oldData.orderIndex + 1;
        this.replacementCostLandForm.reset();
        this.replacementCostLandForm.patchValue(this._data.replacementCostLand);
    }
    saveAndNew() {
        const replacementCostLand = this.replacementCostLandForm.getRawValue();
        this.save(replacementCostLand, true)
    }
    saveAndClose() {
        const replacementCostLand = this.replacementCostLandForm.getRawValue();
        this.save(replacementCostLand);

    }
    save(replacementCostLand, isOpen = false) {
        this.replacementCostLandService.createReplacementCostLand(replacementCostLand).subscribe((response) => {
            if (response.isSuccess) {
                // Show a success message
                this._alertMessage.success("ReplacementCostLand added successfully");
                // Close the dialog
                if (!isOpen) {
                    this._matDialogRef.close(response);
                }
                else {
                    this.setResetForm(replacementCostLand);
                }
            }
            else {
                this._alertMessage.error(response.errors.join("\n"));
            }
        });
    }

    // saveAndClose() {
    //     const replacementCostLand = this.replacementCostLandForm.getRawValue();

    //     this.replacementCostLandService.createReplacementCostLand(replacementCostLand).subscribe((response) => {
    //         if (response.isSuccess) {
    //             // Show a success message
    //             this._alertMessage.success("ReplacementCostLand added successfully");
    //             // Close the dialog
    //             this._matDialogRef.close(response);
    //         }
    //         else {
    //             this._alertMessage.error(response.errors.join("\n"));
    //         }
    //     });
    // }

    updateAndClose() {

        const replacementCostLand = this.replacementCostLandForm.getRawValue();

        this.replacementCostLandService.updateReplacementCostLand(replacementCostLand).subscribe((response) => {
            if (response.isSuccess) {
                // Show a success message
                this._alertMessage.success("ReplacementCostLand updated successfully");
                // Close the dialog
                this._matDialogRef.close(response);
            }
            else {
                this._alertMessage.error(response.errors.join("\n"));
            }
        });

    }

    onClose(): void {
        this._matDialogRef.close();
    }

    displayOptionsFn(options: CommonDropDown[]): (name: string) => string {
        return (name: string) => {
            const correspondingOption = Array.isArray(options) ? options.find(option => option.name === name) : null;
            return correspondingOption ? correspondingOption.name : '';
        }
    }

    private _optionsfilter(name: string): CommonDropDown[] {
        const filterValue = name.toString().toLowerCase();

        return this.options.filter(option => option.name.toLowerCase().includes(filterValue));
    }
}
